import { render, staticRenderFns } from "./PopsFolderClinic.vue?vue&type=template&id=c358740c&scoped=true"
import script from "./PopsFolderClinic.vue?vue&type=script&lang=js"
export * from "./PopsFolderClinic.vue?vue&type=script&lang=js"
import style0 from "./PopsFolderClinic.vue?vue&type=style&index=0&id=c358740c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c358740c",
  null
  
)

export default component.exports